import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { db } from "../firebase";
import { collection, query, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Viewer from "./../Components/Viewer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick} style={{ ...arrowStyle, left: "10px" }}>
      <FaChevronLeft style={{ color: "#000" }} />
    </div>
  );
};

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick} style={{ ...arrowStyle, right: "-40px" }}>
      <FaChevronRight  style={{ color: "#000" }} />
    </div>
  );
};

const arrowStyle = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: "10",
  cursor: "pointer",
  fontSize: "24px",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  color: "#000",
  borderRadius: "50%",
  padding: "10px",
};

function Events() {
  const [eventData, setEventData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "Event"));
      const querySnapshot = await getDocs(q);
      const events = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setEventData(events);
    };
    fetchData();
  }, []);

  const handleEventClick = (eventId) => {
    navigate(`/events/${eventId}`);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
  };

  return (
    <Container style={{ backgroundColor: "#f5f5f5", padding: "40px", borderRadius: "10px" }}>
      <Row className="justify-content-center">
        <Col md={10}>
          <Slider {...settings}>
            {eventData.map((event) => (
              <div key={event.id} onClick={() => handleEventClick(event.id)} style={{ cursor: "pointer" }}>
                <div className="event-card" style={eventCardStyle}>
                  {event.images && event.images.length > 0 ? (
                    <img src={event.images[0]} alt="Event Thumbnail" style={imageStyle} />
                  ) : (
                    <p>No Images Available</p>
                  )}
                  <h4 style={titleStyle}>{event.field1}</h4>
                  <Viewer html={event.field2} />
                </div>
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </Container>
  );
}

const eventCardStyle = {
  background: "white",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  textAlign: "center",
};

const imageStyle = {
  width: "100%",
  height: "250px",
  objectFit: "cover",
  borderRadius: "10px",
};

const titleStyle = {
  color: "#333",
  marginTop: "10px",
  fontWeight: "bold",
};

export default Events;  